import { useEffect, useState } from 'react';

export interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

/** Reload whenever `deps` change. Every list/view gets loading + error states (PRD §14.4). */
export function useAsync<T>(load: () => Promise<T>, deps: ReadonlyArray<unknown> = []): AsyncState<T> {
  const [state, setState] = useState<AsyncState<T>>({ data: null, loading: true, error: null });
  useEffect(() => {
    let live = true;
    setState({ data: null, loading: true, error: null });
    load()
      .then((data) => live && setState({ data, loading: false, error: null }))
      .catch(
        (e: unknown) =>
          live && setState({ data: null, loading: false, error: e instanceof Error ? e.message : 'Load failed' }),
      );
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller owns the dependency list
  }, deps);
  return state;
}
